<template>
	<div class="tc-layer-chart" v-bind:style="styleLayoutChart">
		<TCChartContent 
			v-for="item in items"
			v-bind:key="item.code"
			v-bind:item="item"
			v-bind:isEditable="isEditable"
			v-bind:ghost_schedule="ghost_schedule"
			v-bind:bar_editing="bar_editing"
			v-on:bar-move-start="barMoveStart"
			v-on:request-ghost-schedule="onRequestGhostSchedule"
			v-on:bar-stretch-start="barStretchStart"
			v-on:hscroll-stop="onHScrollStop"
			v-on:update_schedule_info="updateScheduleInfo" />
	</div>
</template>
<script>
import TCChartContent from './TCChartContent';
export default {
	name:"TCLayerChart",
	props: [
		"items",
		"isEditable",
		"ghost_schedule",
		"bar_editing",
	],
	components: {
		TCChartContent,
	},
	data () {
		return {
		};
	},
	methods: {
		barMoveStart: function(e) {
			this.$emit('bar-move-start', e);
		},
		barStretchStart: function(e) {
			this.$emit('bar-stretch-start', e);
		},
		updateScheduleInfo: function(e) {
			this.$emit('update_schedule_info', e);
		},
		onRequestGhostSchedule: function(e) {
			this.$emit("request-ghost-schedule", e);
		},
		onHScrollStop: function(e) {
			this.$emit('hscroll-stop', e);
		},
	},
	computed: {
		styleLayoutChart: function() {
			return {
				width: this.$store.getters['chart/innerWidth'] + 'px',
				height: 100 + '%',
			};
		},
	},
}
</script>
<style>
	.tc-layer-chart {
		position: relative;
		width: 100%;
		z-index: 100;
	}
</style>
